// useGemini presets where gpt-4o-mini is NOT a viable fallback (e.g. they rely
// on Gemini web grounding), so the "Standard (Legacy)" model option is hidden
// in the UI and never honored on the server for them.
//
// Kept apart from `presets.ts` so client code that only needs this list (the
// AI model menus) doesn't pull the whole presets catalogue into its bundle.
export const LEGACY_MODEL_EXCLUDED_SLUGS = ['news-article-generator'];
